import { RecommendedCompsStatistics } from '@aloft/toolkit-shared';
import { Button, Flex, Typography } from '@aloft/toolkit-sui';

import { FilterStatistics } from './internal/FilterDrawer/FilterStatistics.tsx';

type RecommendedCompsModalHeaderProps = {
  statistics?: RecommendedCompsStatistics;
  isLoading: boolean;
  onExportCSV: () => void;
  onSettingsClick: () => void;
};

export const RecommendedCompsModalHeader = ({
  statistics,
  isLoading,
  onExportCSV,
  onSettingsClick,
}: RecommendedCompsModalHeaderProps) => (
  !isLoading && <Flex alignItems="center" justifyContent="space-between" flex={1} paddingRight="40px">
    <Flex alignItems="baseline" gap="32px" overflow="hidden">
      <Typography variant="h2">Recommended Comps</Typography>
      <FilterStatistics statistics={statistics} isLoading={isLoading} showStatusCounts={false} />
    </Flex>

    <Flex alignItems="center" gap="16px" flexShrink={0}>
      <Button
        icon="download"
        size="sm"
        variant="secondary"
        text="Export to CSV"
        onClick={onExportCSV}
      />
      <Button
        icon="settings-3"
        size="sm"
        variant="secondary"
        text="Settings"
        onClick={onSettingsClick}
      />
    </Flex>
  </Flex>
);
